export enum Stage {
  Start,
  Phone,
  Varify
}
